
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-compiler/index?{\"id\":\"data-v-0020a025\",\"scoped\":false,\"hasInlineConfig\":false}!scss-loader!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./mgmshare.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./mgmshare.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0020a025\"}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./mgmshare.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/views/mgmshare.vue
// module id = 173
// module chunks = 0